import yup from "lib/yup-extended";

export const validations = yup.object({
  selectedProducts: yup
    .array()
    .min(1, "Selecione pelo menos uma solução."),
});
